/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithCodeItemRequestBuilder, WithCodeItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/CoolingRegimeGenus/ByCode
 */
export interface ByCodeRequestBuilder extends BaseRequestBuilder<ByCodeRequestBuilder> {
    /**
     * Gets an item from the Kiota.TypeScript.Api.api.vWithVersion.CoolingRegimeGenus.ByCode.item collection
     * @param code The code.
     * @returns {WithCodeItemRequestBuilder}
     */
     byCode(code: number) : WithCodeItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const ByCodeRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/CoolingRegimeGenus/ByCode";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ByCodeRequestBuilderNavigationMetadata: Record<Exclude<keyof ByCodeRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCode: {
        requestsMetadata: WithCodeItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["code"],
    },
};
/* tslint:enable */
/* eslint-enable */
